import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const copyrightHolder = process.env.REACT_APP_COPYRIGHT_HOLDER || '数理阶梯';
  const icpNumber = process.env.REACT_APP_ICP_NUMBER || '京ICP备12345678号-1';
  const publicSecurityNumber = process.env.REACT_APP_PUBLIC_SECURITY_NUMBER || '京公网安备 11010502012345号';

  return (
    <div className="footer-container">
      <div className="footer-content">
        <div className="footer-item">
          Copyright © {currentYear} {copyrightHolder} 版权所有
        </div>
        <div className="footer-item">
          备案号：{icpNumber}
        </div>
        <div className="footer-item">
          {publicSecurityNumber}
        </div>
      </div>
    </div>
  );
};

export default Footer;
